import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["input", "submit", "reset"]

  connect() {
    this.form = this.element.closest("form")

    // This bodge brought to you by targets marked data-turbo-permanent not always being immediately available
    requestAnimationFrame(() => {
      if (this.hasInputTarget) {
        this.update()
      }
    })
  }

  update() {
    this.submitTarget.classList.toggle("hidden", this.searchQuery() != "")
    this.resetTarget.classList.toggle("hidden", this.searchQuery() == "")
  }

  clear() {
    this.inputTarget.value = ""
    this.update()
    this.form.requestSubmit()
  }

  searchQuery() {
    return this.inputTarget.value.trim()
  }

  search() {
    this.form.requestSubmit()
  }
}
